import { FC } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'
import RightArrowIcon from 'src/Assets/Svg/pages-icons/RightArrow.svg?react'
import { IconButton } from 'src/Components/Buttons/IconButton'

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 24px 32px;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  cursor: pointer;
`

const Text = styled.span`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize18};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  flex-grow: 1;
  user-select: none;
`

type Icon = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string
  }
>
export interface PlatformButtonProps {
  title: string
  icon: Icon
  isNew?: boolean
  onClick: () => void
}

export const PlatformButton: FC<PlatformButtonProps> = ({
  title,
  icon: Icon,
  onClick,
}) => (
  <Container onClick={onClick}>
    <Icon width={32} height={32} />
    <Text>
      <span>{title}</span>
    </Text>
    <IconButton>
      <RightArrowIcon />
    </IconButton>
  </Container>
)
